var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { throttle } from '@tencent/exeditor3-core';
const toIntArray = (n) => Array.from({ length: n }).map((_, i) => i);
const cellWidth = 16;
const cellGap = 2;
const edgeSpace = 10;
const minRowCount = 5;
const minColumnCount = 5;
const maxRowCount = 10;
const maxColumnCount = 10;
let ExEditorMenubarTablePanel = class ExEditorMenubarTablePanel extends LitElement {
    constructor() {
        super(...arguments);
        this.t = (token, fallback) => fallback !== null && fallback !== void 0 ? fallback : token;
        this.columnCount = 1;
        this.rowCount = 1;
        this.displayColumnCount = minColumnCount;
        this.displayRowCount = minRowCount;
        this.handleMousemoveDebounce = throttle(this.handleMousemove.bind(this), 15);
    }
    handleMousemove(event) {
        const cellSize = cellWidth + cellGap * 2;
        const rect = this.picker.getBoundingClientRect();
        const offsetX = event.x - rect.x;
        const offsetY = event.y - rect.y;
        // 选择行列
        let column = Math.ceil(offsetX / cellSize) || 1;
        let row = Math.ceil(offsetY / cellSize) || 1;
        column = Math.min(column, maxColumnCount);
        row = Math.min(row, maxRowCount);
        this.rowCount = row || 1;
        this.columnCount = column || 1;
        // 扩展/收缩选择区域
        if (offsetX > rect.width - edgeSpace &&
            this.displayColumnCount < maxColumnCount) {
            this.displayColumnCount++;
        }
        else if (column < this.displayColumnCount &&
            this.displayColumnCount >= minColumnCount) {
            this.displayColumnCount = Math.max(column, minColumnCount);
        }
        if (offsetY > rect.height - edgeSpace &&
            this.displayRowCount < maxRowCount) {
            this.displayRowCount++;
        }
        else if (row < this.displayRowCount &&
            this.displayRowCount >= minRowCount) {
            this.displayRowCount = Math.max(row, minColumnCount);
        }
    }
    handleClick(event) {
        const cellSize = cellWidth + cellGap * 2;
        const rect = this.picker.getBoundingClientRect();
        const offsetX = event.x - rect.x;
        const offsetY = event.y - rect.y;
        const column = Math.ceil(offsetX / cellSize);
        const row = Math.ceil(offsetY / cellSize);
        this.dispatchEvent(new CustomEvent('select', {
            detail: {
                rows: row,
                cols: column,
            },
        }));
        this.resetPicker();
    }
    renderCell(row, column) {
        const key = `${row}x${column}`;
        const active = row < this.rowCount && column < this.columnCount;
        return html ` <span key=${key} class="cell" ?active=${active}></span> `;
    }
    resetPicker() {
        this.columnCount = 1;
        this.rowCount = 1;
        this.displayColumnCount = minColumnCount;
        this.displayRowCount = minRowCount;
    }
    render() {
        const { t } = this;
        const pickerWidth = this.displayColumnCount * (cellWidth + cellGap * 2);
        return html `
      <div class="tip">
        <span class="text">${t('选择行列')}</span>
        <span class="count"> ${this.columnCount} x ${this.rowCount} </span>
      </div>

      <div
        class="picker"
        @mousemove=${this.handleMousemoveDebounce}
        @click=${this.handleClick}
        style="width: ${pickerWidth}px"
      >
        ${toIntArray(this.displayRowCount).map((row) => toIntArray(this.displayColumnCount).map((column) => this.renderCell(row, column)))}
      </div>
    `;
    }
};
ExEditorMenubarTablePanel.styles = [
    css `
      :host {
        display: block;
        padding: 10px;
      }
      .tip {
        display: flex;
        color: #666;
        margin-bottom: 10px;
        font-size: 12px;
      }
      .tip > .count {
        flex: 1;
        text-align: right;
      }
      .picker {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        margin: -${cellGap}px;
        margin-right: -${cellGap + edgeSpace}px;
        margin-bottom: -${cellGap + edgeSpace}px;
        padding-right: ${edgeSpace}px;
        padding-bottom: ${edgeSpace}px;
        cursor: pointer;
      }
      .cell {
        display: block;
        width: ${cellWidth}px;
        height: ${cellWidth}px;
        margin: ${cellGap}px;
        background-color: #f2f2f2;
        pointer-events: none;
      }
      .cell[active] {
        background-color: var(
          --exeditor-table-panel-cell-active-color,
          #b2d1ff
        );
      }
    `,
];
__decorate([
    property()
], ExEditorMenubarTablePanel.prototype, "t", void 0);
__decorate([
    query('.picker')
], ExEditorMenubarTablePanel.prototype, "picker", void 0);
__decorate([
    state()
], ExEditorMenubarTablePanel.prototype, "columnCount", void 0);
__decorate([
    state()
], ExEditorMenubarTablePanel.prototype, "rowCount", void 0);
__decorate([
    state()
], ExEditorMenubarTablePanel.prototype, "displayColumnCount", void 0);
__decorate([
    state()
], ExEditorMenubarTablePanel.prototype, "displayRowCount", void 0);
ExEditorMenubarTablePanel = __decorate([
    customElement('exeditor-toolbar-table-panel')
], ExEditorMenubarTablePanel);
export { ExEditorMenubarTablePanel };
//# sourceMappingURL=table-panel.js.map